import React from 'react';
import { View, StyleSheet, Text, Image } from 'react-native';
import { translate } from 'react-i18next';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

const isSmallMobile = window.innerWidth <= 350;
class TrackingWorkoutTotals extends React.PureComponent {
    render() {
        const { t } = this.props;
        return (
            <View style={styles.container}>
                <Text style={styles.totalWorkouts}>Total Workouts</Text>
                <View style={styles.burnContainer}>
                    <View style={[styles.square, {backgroundColor: Theme.GREY}]}/>
                    <Text style={styles.burnWorkouts}>{`${this.props.totals.burn ? this.props.totals.burn : 0} ${this.props.totals.burn === 1 ? t('burnWorkout') : t('burnWorkouts')}`}</Text>
                </View>
                <View style={styles.buildContainer}>
                    <View style={[styles.square, {backgroundColor: Theme.GREY_DARK_MEDIUM}]}/>
                    <Text style={styles.buildWorkouts}>{`${this.props.totals.build ? this.props.totals.build : 0} ${this.props.totals.build === 1 ? t('buildWorkout') : t('buildWorkouts')}`}</Text>
                </View>
                <View style={styles.buildContainer}>
                    <View style={[styles.square, {backgroundColor: Theme.GREY_DARK}]}/>
                    <Text style={styles.buildWorkouts}>{`${this.props.totals.balance ? this.props.totals.balance : 0} ${t('balance')}`}</Text>
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        alignSelf: 'flex-end',
        width: '100%',
        justifyContent: 'center'
    },
    buildContainer: {
        flexDirection: 'row',
        marginTop: defaultScale(10)
    },
    burnContainer: {
        flexDirection: 'row',
    },
    totalWorkouts: {
        ...Theme.graphStyle.customMedium14,
        color: Theme.GREY_DARK,
        letterSpacing: 0,
        lineHeight: defaultScale(20),
        marginTop: defaultScale(10),
        marginBottom: defaultScale(16),
    },
    burnWorkouts: {
        color: Theme.GREY_DARK,
        fontSize: isSmallMobile ? 
            Theme.graphStyle.customLight13.fontSize : 
            Theme.graphStyle.customMedium16.fontSize,
        fontFamily: Theme.Custom500,
        letterSpacing: 0,
        lineHeight: defaultScale(20),
        marginTop: defaultScale(4),
        marginLeft: defaultScale(6),
    },
    buildWorkouts: {
        color: Theme.GREY_DARK,
        fontSize: isSmallMobile ? 
            Theme.graphStyle.customLight13.fontSize : 
            Theme.graphStyle.customMedium16.fontSize,
        fontFamily: Theme.Custom500,
        letterSpacing: 0,
        lineHeight: defaultScale(20),
        marginTop: defaultScale(4),
        marginLeft: defaultScale(6),
    },

    square: {
        width: defaultScale(14),
        height: defaultScale(14),
        marginTop: defaultScale(8),
    },
    orangeSquare: {
        width: defaultScale(14),
        height: defaultScale(14),
        marginTop: defaultScale(8),
    },
    whiteSquare: {
        width: defaultScale(14),
        height: defaultScale(14),
        marginTop: defaultScale(24),
    },
});

export default translate(['workoutHistory'])(TrackingWorkoutTotals);
